/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radar Chart Maker (Spider Chart, Free) — Toolverse`)
};

const es_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Radar (Gráfico de Araña, Gratis) — Toolverse`)
};

const de_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radardiagramm-Ersteller (Spinnendiagramm, Kostenlos) — Toolverse`)
};

const nl_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radardiagrammaker (spiderdiagram, gratis) — Toolverse`)
};

const fr_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme radar (en araignée, gratuit) — Toolverse`)
};

const it_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici radar (a ragno, gratuito) — Toolverse`)
};

const pt_br2_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Radar (Gráfico de Aranha, Grátis) — Toolverse`)
};

const pt_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos Radar (Gráfico Aranha, Grátis) — Toolverse`)
};

const ja_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーダーチャート作成ツール（スパイダーチャート、無料） — Toolverse`)
};

const zh_radar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雷达图制作工具（蜘蛛图，免费）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_meta_title", locale)
	if (locale === "en") return en_radar_meta_title(inputs)
	if (locale === "es") return es_radar_meta_title(inputs)
	if (locale === "de") return de_radar_meta_title(inputs)
	if (locale === "nl") return nl_radar_meta_title(inputs)
	if (locale === "fr") return fr_radar_meta_title(inputs)
	if (locale === "it") return it_radar_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_radar_meta_title(inputs)
	if (locale === "pt") return pt_radar_meta_title(inputs)
	if (locale === "ja") return ja_radar_meta_title(inputs)
	return zh_radar_meta_title(inputs)
};